/* eslint-disable react-hooks/exhaustive-deps */
import { Tag, Form, BackTop, Spin, Button } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import StepWizard from 'react-step-wizard';
import IconBack from '../../../assets/Images/icons/icon-back';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import ModalDelete from '../../../components/Shared/modal/delete';

import { ROUTER } from '../../../constants/router';
import useNotify from '../../../context/Notification/useNotify';
import PolicyService from '../../../services/Policy.service';
import { useBlocker } from '../../../util/usePrompt';

import New from './components/FreeForm';
import NewTopic from './components/NewTopic';

import StepList from './components/StepList';
import StepPreview from './components/StepPreview';
import GlobalService from '../../../services/Global.service';
import ModalConfirm from '../../../components/Shared/modal/confirm';
import { POLICY_NAME } from '../POLICY';

const { Provider } = Form;

const FreeFormDetail = () => {
    const { t } = useTranslation();
    let navigate = useNavigate();
    const { id } = useParams();
    const notify = useNotify();

    const [state, updateState] = useState();
    const [applications, setApplications] = useState([]);

    const [currentSelectList, setCurrentSelectList] = useState(0);
    const [newTopic, setNewTopic] = useState([]);

    const [loading, setLoading] = useState(false);
    const [loading_, setLoadingSave] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [loadingSaveDraft, setLoadingSaveDraft] = useState(false);
    const [editMode, setEditMode] = useState(false);
    // form
    const [freeFormData] = Form.useForm();
    const [newTopicForm] = Form.useForm();

    const [previewData, setPreviewData] = useState();
    const [rawData, setRawData] = useState();

    const [dsType, setDsType] = useState([]);
    const [data, setData] = useState([]);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [isPublishedVersion, setIsPublishedVersion] = useState();
    const [previewMode, setPreviewMode] = useState(false);
    const [idChange, setIdChange] = useState(false);
    const [errorMode, setErrorMode] = useState([]);
    const [isAddingNewTopic, setIsAddingNewTopic] = useState(false); 
    const [saveDraftState, setSaveDraftState] = useState(false);

    // check validations

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    const setInstance = (SW) => {
        updateState({
            ...state,
            SW,
        });
    };

    const handleSelectTopic = (selectedTopic) => {
        setNewTopic(selectedTopic);
    };

    const getFreeForm = async () => {
        try {
            setLoading(true);
            const { data } = await PolicyService.getFreeForm(id);
            if (data?.resultData) {
                const data_ = data?.resultData;
                const transformedData = transformApiData(data_);
                setData(transformedData);
                currentSelectList ? setCurrentSelectList(currentSelectList) : setCurrentSelectList(0);
                if (data_?.freeFormPolicy.isPublish && !saveDraftState) {
                    setPreviewMode(data_?.freeFormPolicy.isPublish);
                    setIsPublishedVersion(data_?.freeFormPolicy.version);
                    const payload = genarateData(transformedData, true, dsType);
                    setPreviewData(payload);
                }
                setRawData(data_);
                setLoading(false);
                setEditMode(true);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    };

    const transformApiData = (apiResponse) => {
        const { freeFormPolicy, freeFormDataList } = apiResponse;

        // Transform freeFormPolicy into sequence 0 object
        const transformedPolicy = {
            isDefault: true,
            sequence: 0,
            freeFormPolicyId: freeFormPolicy.freeFormPolicyId,
            freeFormPolicyNameTh: freeFormPolicy.freeFormPolicyNameTh,
            freeFormPolicyNameEn: freeFormPolicy.freeFormPolicyNameEn,
            freeFormCompanyNameTh: freeFormPolicy.freeFormCompanyNameTh,
            freeFormCompanyNameEn: freeFormPolicy.freeFormCompanyNameEn,
            freeFormIntroductionTh: freeFormPolicy.freeFormIntroductionTh,
            freeFormIntroductionEn: freeFormPolicy.freeFormIntroductionEn,
            freeFormCompanyLogoId: freeFormPolicy.freeFormCompanyLogoId,
            freeFormPolicyDataSubjectType:
                freeFormPolicy.freeFormPolicyDataSubjectType.map(
                    (ds) => ds.freeFormDataSubjectId
                ),
            freeFormTopicDataId: '',
            freeFormTitleTh: 'ชื่อนโยบายและประเภทเจ้าของข้อมูล',
            freeFormTitleEn: 'Policy name and data subject type',
            freeFormContentTh: '',
            freeFormContentEn: '',
            freeFormIsDisplay: true,
        };
        // Transform freeFormDataList into sequence > 0 objects
        const transformedDataList = freeFormDataList.map((item) => ({
            isDefault: false,
            sequence: item.sequence,
            freeFormPolicyId: item.freeFormPolicyId,
            freeFormPolicyNameTh: '',
            freeFormPolicyNameEn: '',
            freeFormCompanyNameTh: '',
            freeFormCompanyNameEn: '',
            freeFormIntroductionTh: '',
            freeFormIntroductionEn: '',
            freeFormCompanyLogoId: '',
            freeFormPolicyDataSubjectType: [],
            freeFormTopicDataId: item.freeFormTopicDataId,
            freeFormTitleTh: item.freeFormTitleTh,
            freeFormTitleEn: item.freeFormTitleEn,
            freeFormContentTh: item.freeFormContentTh,
            freeFormContentEn: item.freeFormContentEn,
            freeFormIsDisplay: item.freeFormIsDisplay,
        }));

        const combinedData = [transformedPolicy, ...transformedDataList];
        return combinedData.sort((a, b) => a.sequence - b.sequence);
    };

    const getNextVersion = () => {
        let item = '';
        let version = isPublishedVersion;
        for (let index = 0; index <= 3; index++) {
            if (version?.split('.')[0][index] !== '0') {
                item = version
                    ?.split('.')[0]
                    ?.slice(index, version?.split('.')[0]?.length);
                break;
            }
        }
        item = String(Number(item) + 1);
        switch (item?.length) {
            case 1:
                item = '000'.concat(`${item}.0`);
                break;
            case 2:
                item = '00'.concat(`${item}.0`);
                break;
            case 3:
                item = '0'.concat(`${item}.0`);
                break;
            default:
                item = item.concat(`.0`);
                break;
        }
        return item;
    };
    const getDsTypeDropdown = async () => {
        try {
            const { data } = await GlobalService.getDs();
            if (data?.resultData) {
                setDsType(data?.resultData?.dataSubjectType);
            }
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        const initializeForm = async () => {
            if (dsType.length > 0) {
                await getFreeForm(); 
            }
        };
        initializeForm();
    }, [dsType]);
    useEffect(() => {
        const initializeForm = async () => {
            await getDsTypeDropdown(); 
            if (dsType.length > 0) { 
                await getFreeForm(); 
            } 
        };
    
        initializeForm();
    }, [id, idChange]);

    const onFormChange = (name, info) => {
        if (info.changedFields.length > 0) {
            setChange(true);
        }
    };

    const handleError = (sequence, isValid) => {
        setErrorMode((prevErrorMode) => {
            if (isValid) {
                if (prevErrorMode.includes(sequence)) {
                    setCurrentSelectList(sequence)
                }
                return prevErrorMode.filter((error) => error !== sequence);
            } else {
                if (!prevErrorMode.includes(sequence)) {
                    const error = [...prevErrorMode, sequence]
                    const sortError = error.sort((a, b) => a - b);
                    error.includes(0) ?  setCurrentSelectList(0) :  setCurrentSelectList(sortError[0])
                  
                    return [...prevErrorMode, sequence];
                }
            }
            return prevErrorMode;
        });
    };

    const validateSequence0 = async () => {
        const policyData = data[0];

        if (
            !policyData.freeFormPolicyNameTh ||
            !policyData.freeFormPolicyNameEn ||
            !policyData.freeFormPolicyDataSubjectType
        ) {
            handleError(0, false);
            await new Promise((resolve) => setTimeout(resolve, 0));
            try {
                await freeFormData.validateFields();
            } catch (error) {}
            return false;
        } 
        handleError(0, true);
        return true;
    };

    const validateSequencesGreaterThan0 = () => {
        let isValid = true;
        const checkSequence = data.filter((item) => item.sequence > 0);
        if (checkSequence.length > 0) {
            checkSequence.forEach(async (item) => {
                if (item.sequence > 0) {
                    if (!item.freeFormTitleTh || !item.freeFormContentTh || item.freeFormContentTh === "<p><br></p>") {
                        isValid = false;
                        handleError(item.sequence, false);
                        await new Promise((resolve) =>
                            setTimeout(resolve, item.sequence)
                        );
                        try {
                            await newTopicForm.validateFields();
                        } catch (error) {}
                    } else {
                        handleError(item.sequence, true);
                    }
                }
            });
        }
        return isValid;
    };

    const validateAllSequences = async () => {
        const isSequence0Valid = await validateSequence0();
        const areOtherSequencesValid = await validateSequencesGreaterThan0();
         if (errorMode.length > 0){
            if (errorMode.includes(0)){
                validateSequence0()
                setCurrentSelectList(0);
            } else {
                const sortError = errorMode.sort((a, b) => a - b);
                setCurrentSelectList(sortError[0]);
            }
        }
       

        return isSequence0Valid && areOtherSequencesValid;
    };

    const onPreview = async () => {
        const isValid = await validateAllSequences();

        if (isValid) {
            setPreviewMode(true);
            genaratePayload(null, false, true); // Proceed to preview
        }
    };


    const genarateData = (data, isPublish, dsTypeData) => {
        let payload = {};
        let freeFormPolicyDataSubjectType = [];
        const freeFormPolicyData = data[0]; // Assuming sequence 0 contains policy data
        const dsTypeGroup = freeFormPolicyData.freeFormPolicyDataSubjectType;
        if (dsTypeGroup) {
            const dsTypefilter = dsTypeData.filter((ds) =>
                dsTypeGroup.includes(ds.id)
            );
            freeFormPolicyDataSubjectType = dsTypefilter.map((ds) => {
                return {
                    freeFormDataSubjectId: ds.id,
                    freeFormDataSubjectNameTh: ds.nameTh,
                    freeFormDataSubjectNameEn: ds.nameEn,
                };
            });
        }

        // Generate freeFormPolicy object from sequence 0
        const freeFormPolicy = {
            isPublish: isPublish,
            freeFormPolicyId: freeFormPolicyData.freeFormPolicyId || '',
            freeFormPolicyNameTh: freeFormPolicyData.freeFormPolicyNameTh,
            freeFormPolicyNameEn: freeFormPolicyData.freeFormPolicyNameEn,
            freeFormCompanyNameTh:
                freeFormPolicyData.freeFormCompanyNameTh,
            freeFormCompanyNameEn:
                freeFormPolicyData.freeFormCompanyNameEn,
            freeFormCompanyLogoId: freeFormPolicyData.freeFormCompanyLogoId,
            freeFormIntroductionTh: freeFormPolicyData.freeFormIntroductionTh,
            freeFormIntroductionEn: freeFormPolicyData.freeFormIntroductionEn,
            freeFormEffectiveDate: null,
            freeFormPolicyDataSubjectType: freeFormPolicyDataSubjectType,
        };
        // Generate freeFormDataList from sequences greater than 0
        const freeFormDataList = data
            .filter((item) => item.sequence > 0)
            .map((item) => ({
                freeFormTopicDataId: item.freeFormTopicDataId || '',
                freeFormTitleTh: item.freeFormTitleTh,
                freeFormTitleEn: item.freeFormTitleEn || '',
                freeFormContentTh: item.freeFormContentTh,
                freeFormContentEn: item.freeFormContentEn || '',
                freeFormIsDisplay: item.freeFormIsDisplay || true,
                sequence: item.sequence,
            }));

        // Final payload structure
        payload = {
            freeFormPolicy,
            freeFormDataList,
        };
        return payload;
    };
    const genaratePayload = (name, isPublish, isPreview = false) => {
        const payload = genarateData(data, isPublish, dsType);
        if (!isPreview) {
            PolicyService.updateFreeForm(payload)
                .then(({ data }) => {
                    if (data.resultCode === 1) {
                        setLoadingSave(false);
                        setLoadingSaveDraft(false);
                        notify({
                            title: t('common.Success'),
                            description: t('Successfully saved data'),
                        });
                        if (!isPublish) {
                            const freeFormPolicyId =
                                data?.resultData?.freeFormPolicyId;
                            setOpenChange(false);
                            setChange(false);
                            setIdChange(!idChange);
                            navigate(
                                ROUTER?.POLICY?.FREE_FORM +
                                    `/${freeFormPolicyId}`
                            );
                            setCurrentSelectList(currentSelectList)
                            // getFreeForm();
                        } else {
                            setOpenConfirm(false);
                            navigate(
                                navigate(
                                    navigate(
                                        `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.FREE_FORM}`
                                    )
                                )
                            );
                        }
                    } else {
                        setLoadingSave(false);
                        setLoadingSaveDraft(false);
                        notify({
                            type: 'error',
                            title: t('common.Fail'),
                            description: t('Failed to confirmed data'),
                        });
                    }
                })
                .catch((error) => {
                    setLoadingSave(false);
                    setLoadingSaveDraft(false);
                });

            if (!isPublish) setLoadingSaveDraft(true);
            else setLoadingSave(true);

            setOpenChange(false);
            setChange(false);
        } else {
            setPreviewData(payload);
        }
    };

    const saveDraft = async () => {
        const isValid = await validateAllSequences();
        setSaveDraftState(true);
        if (isValid) {
            genaratePayload(null, false); 
        }
    };

    const onFormFinish = async (name, _) => {
        const isValid = await validateAllSequences();
        if (isValid) {
            genaratePayload(name, true);
        }
    };

    const _getTagStatus = (item) => {
        switch (item?.status) {
            case 'Draft':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        {item?.status} {item?.version}
                    </Tag>
                );
            case 'Published':
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#4ACE8F', borderColor: '#4ACE8F' }}
                    >
                        {item?.status} {item?.latestPublishVersion}
                    </Tag>
                );
            default:
                return (
                    <Tag
                        className="rounded-xl text-center"
                        style={{ color: '#9A9A9A', borderColor: '#9A9A9A' }}
                    >
                        Draft 0000.0
                    </Tag>
                );
        }
    };

    const handleFormChange = (changedFields, allValues, sequence) => {
        const updatedData = [...data];
        const updatedTopic = { ...updatedData[sequence], ...allValues };
        updatedData[sequence] = updatedTopic;

        if (sequence === 0) {
            updatedData[0].freeFormCompanyLogoId = allValues.freeFormCompanyLogoId;
        }

        setData(updatedData);
    };

    const deleteTopic = (sequence) => {
        const updatedData = data.filter((item, index) => index !== sequence);
        const reindexedData = updatedData.map((item, index) => ({
            ...item,
            sequence: index,
        }));
        handleError(sequence, true);
        setData(reindexedData);
        setCurrentSelectList(0);
    };

    return (
        <>
            <div className="title flex items-center">
                <div
                    className="cursor-pointer mr-3 space-x-2"
                    onClick={() => {
                        navigate(
                            `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.FREE_FORM}`
                        );
                    }}
                >
                    <IconBack />
                    <span>
                        {id === 'new'
                            ? t('Add Free Form')
                            : t('Edit Free Form')}
                    </span>
                </div>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Policy')} / {t('Free Form')} /{' '}
                </span>
                <span>
                    {id === 'new' ? t('Add Free Form') : t('Edit Free Form')}
                </span>
            </div>
            <div className="mt-4 grid grid-cols-4 gap-4">
                {!previewMode && (
                    <StepList
                        setCurrentSelectList={setCurrentSelectList}
                        currentSelectList={currentSelectList}
                        SW={state?.SW}
                        isNew={id === 'new'}
                        onSelectTopic={handleSelectTopic}
                        setData={setData}
                        data={data}
                        errorMode={errorMode}
                        handleError={handleError}
                        setIsAddingNewTopic={setIsAddingNewTopic}
                        validateSequence0={validateSequence0}
                        validateSequencesGreaterThan0={validateSequencesGreaterThan0}
                    />
                )}
                <div
                    className={classNames({
                        'col-span-3': !previewMode,
                        'col-span-4': previewMode,
                    })}
                >
                    <div className="px-8 bg-white rounded-md py-4  font-semibold text-base flex flex-row justify-between items-center">
                        <div>
                            <h1 className="text-dark text-2xl font-semibold	">
                                {previewMode
                                    ? t(
                                          'Please verify the accuracy of information before publishing'
                                      )
                                    : t('Free Form')}
                            </h1>
                            <div className="flex flex-row">
                                {_getTagStatus(
                                    id === 'new'
                                        ? 'Draft'
                                        : rawData?.freeFormPolicy
                                )}
                                {rawData?.freeFormPolicy.isPublish &&
                                !previewMode ? (
                                    <p className="mb-0 text-xs	text-gray-PHX font-normal">
                                        {t('LastPublishDate')}:{' '}
                                        {rawData?.freeFormPolicy.publishDate}
                                    </p>
                                ) : (
                                    ''
                                )}
                            </div>
                        </div>
                        <div>
                            <div className="flex gap-4">
                                {!previewMode && (
                                    <div>
                                        <p className="text-xs text-gray-PHX mb-0 font-normal">
                                            {t('Current version')}:{' '}
                                            {rawData?.freeFormPolicy?.version ||
                                                '0000.0'}
                                        </p>
                                        <p className="text-xs text-gray-PHX mb-0 font-normal">
                                            {t('LastUpdate')} :{' '}
                                            {rawData?.freeFormPolicy
                                                ?.updateDate || '-'}
                                        </p>
                                    </div>
                                )}

                                {!previewMode ? (
                                    <>
                                        <Button
                                            type="default"
                                            size="large"
                                            loading={loadingSaveDraft}
                                            onClick={saveDraft}
                                            className="border-purple text-purple px-6"
                                        >
                                            {t('Save Draft')}
                                        </Button>
                                        <Button
                                            // loading={props.loading_}
                                            type="primary"
                                            size="large"
                                            onClick={() => onPreview()}
                                        >
                                            {t('Preview')}
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Button
                                            type="default"
                                            size="large"
                                            loading={loadingSaveDraft}
                                            onClick={saveDraft}
                                            className="border-purple text-purple px-6"
                                        >
                                            {t('Save Draft')}
                                        </Button>
                                        <Button
                                            loading={loading_}
                                            type="primary"
                                            size="large"
                                            onClick={() => onFormFinish()}
                                        >
                                            {t('Save And Publish')}
                                        </Button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    <Spin spinning={loading}>
                        <Provider
                            onFormChange={onFormChange}
                            onFormFinish={onFormFinish}
                        >
                            <div
                                className={`${
                                    previewMode
                                        ? 'mt-0 pt-0 px-6 pb-6'
                                        : 'mt-4 p-6'
                                } bg-white rounded-md overflow-hidden`}
                            >
                                <StepWizard
                                    isHashEnabled
                                    instance={setInstance}
                                    onStepChange={(e) => {
                                        setCurrentSelectList(e.activeStep);
                                    }}
                                >
                                    {!previewMode ? (
                                        currentSelectList === 0 ? (
                                            <New
                                                dsType={dsType}
                                                loading={loading_}
                                                editMode={editMode}
                                                applications={applications}
                                                setApplications={
                                                    setApplications
                                                }
                                                form={freeFormData}
                                                saveDraft={saveDraft}
                                                previewData={rawData}
                                                editData={data[0]}
                                                currentSelectList={
                                                    currentSelectList
                                                }
                                                newTopic={newTopic}
                                                handleError={handleError}
                                                onValuesChange={(
                                                    changedFields,
                                                    allValues
                                                ) =>
                                                    handleFormChange(
                                                        changedFields,
                                                        allValues,
                                                        currentSelectList
                                                    )
                                                }
                                            />
                                        ) : (
                                            <NewTopic
                                                currentSelectList={
                                                    currentSelectList
                                                }
                                                newTopic={
                                                    data[currentSelectList]
                                                }
                                                onValuesChangeData={(
                                                    changedFields,
                                                    allValues
                                                ) =>
                                                    handleFormChange(
                                                        changedFields,
                                                        allValues,
                                                        currentSelectList
                                                    )
                                                }
                                                form={newTopicForm}
                                                onDeleteTopic={() =>
                                                    setOpenDelete(true)
                                                }
                                                handleError={handleError}
                                                setIsAddingNewTopic={setIsAddingNewTopic}
                                                isAddingNewTopic={isAddingNewTopic}
                                            />
                                        )
                                    ) : (
                                        <StepPreview
                                            data={previewData}
                                            setPreviewMode={setPreviewMode}
                                            setCurrentSelectList={
                                                setCurrentSelectList
                                            }
                                        />
                                    )}
                                </StepWizard>
                            </div>
                        </Provider>
                    </Spin>
                </div>
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <ModalConfirm
                open={openConfirm}
                handelClose={() => setOpenConfirm(false)}
                loading={loading_}
                handelOk={() => {
                    onFormFinish(true);
                }}
                title={
                    <div className="flex-column items-center text-center space-y-2">
                        <div className="font-normal text-1xl">
                            {t('Publish this policy')}
                        </div>
                        <Tag
                            className="rounded-xl text-center bg-[#7B67FB]"
                            style={{ color: '#FFFFFF', borderColor: '#FFFFFF' }}
                        >
                            {t('Consent.PublishedVersion')}:{' '}
                            {isPublishedVersion ? getNextVersion() : '0001.0'}
                        </Tag>
                        <div className="font-normal text-[13px] text-[#65707A]">
                            {t('Consent.ModalDesPublish')}
                        </div>
                    </div>
                }
                text=""
            />
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>

            <ModalDelete
                loading={loadingDelete}
                open={openDelete}
                title={t('Confirm Delete')}
                text={t('Do you want to delete Title')}
                handelOk={async () => {
                    setTimeout(async () => {
                        setLoadingDelete(true);
                        deleteTopic(currentSelectList);
                        setLoadingDelete(false);
                        setOpenDelete(false);
                        setCurrentSelectList(0);
                    });
                }}
                handelClose={() => {
                    setOpenDelete(false);
                    setLoading(false);
                }}
            />
        </>
    );
};

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

export default FreeFormDetail;
